export const environment = {
  production: false,
  urlAWS: "https://zpn6n8dc85.execute-api.us-east-1.amazonaws.com/QA",
  campania: "8508",
  origen: "ANSWER_ECOMMERCE_25_mensual",
  campaniaMoto: "8217",
  origenMoto: "ANSWER_MOTO_E-COMM",
  sumaAseguradaNoTerceros: 2000000,
  montoFranquiciaFija: 40000,
  sentritracingOrigins: "http://devanswer.s3-website-us-east-1.amazonaws.com/",
  hideConsole: false,
  chatHogarCustName: "answer_hogar|PreWeb_Chat_IA_Hogar_0%_NA",
  bffUrl: "https://stage-cloud-svc.answerseguros.com.ar/gs-answerecommsales-bff",
  chatApCustName: "answer_ap|Web_Chat_IA_ap_0%_NA",
  campaniaCrossSellHogar: "8237",
  campaniaMotoAltaCilindrada: "8247",
  campaniaDescuentoAntiguead: "8242",
  campaniaCeroKm: "8241",
  celuUrl:
    "https://stage-cloud.web.galiciaseguros.com.ar/gs-answerecommsales-fe-sm/cellphone-insurance/",
  frontendUrl: "https://stage-cloud-int-www.answerseguros.com.ar",
  frontendNewUrl: "https://stage-cloud-int.answerseguros.com.ar",
  apComercialUrl:
    "https://stage-cloud.web.galiciaseguros.com.ar/gs-answer-fe/comercial/",
  bolsoUrl:
    "https://stage-cloud.web.galiciaseguros.com.ar/gs-answerecommsales-fe-sm/personal-belongings/",
  mascotasUrl:
    "https://stage-cloud.web.galiciaseguros.com.ar/gs-answerecommsales-fe-sm/pet-insurance/",
  cotizacionOff: {
    activar: true,
    inicio: "17/10/2026 22:00:00",
    fin: "18/10/2026 06:00:00",
  },
  enableSecurityScripts: false,
  beaconScriptId: "NO_ID",
  redirectScriptUrl: "",
  recpatchaKey: "6LcZx2AsAAAAAG7ejlIlUgcxtvg-HWY6WiW0GZZK",
  braze: {
    enabled: false,
    apiKey: "",
    baseUrl: "",
    enableLogging: false,
  },
};
